import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76326410")

_pushScopeId("data-v-76326410")
const _hoisted_1 = { class: "LTLCargoPayment" }
const _hoisted_2 = { class: "LTLCargoPayment__header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Оформите груз и оплату")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Редактирование")
const _hoisted_6 = { class: "LTLCargoPayment__body" }
const _hoisted_7 = { class: "body__col col-left" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { class: "body__label" }, "Укажите основную информацию о грузе", -1)
const _hoisted_9 = { class: "body__row row-two-inputs" }
const _hoisted_10 = { class: "body__row row-three-inputs" }
const _hoisted_11 = { class: "body__services" }
const _hoisted_12 = { class: "body__services__item" }
const _hoisted_13 = {
  key: 0,
  class: "body__services__item"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_16 = { class: "body__services__item" }
const _hoisted_17 = {
  key: 0,
  class: "body__services__item"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_20 = { class: "body__services__item" }
const _hoisted_21 = {
  key: 0,
  class: "body__services__item"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_24 = { class: "body__checkboxes" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { style: {"font-size":"16px","font-weight":"600","color":"black","line-height":"13.04px","display":"block","margin-left":"6px"} }, " Верифицировать ", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_28 = {
  key: 0,
  class: "body__files"
}
const _hoisted_29 = { class: "body__checkboxes" }
const _hoisted_30 = {
  key: 2,
  class: "body__selects"
}
const _hoisted_31 = {
  key: 3,
  class: "body__warning"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "АВИА: можно отправлять батарейки/аккумуляторы, встроенные в устройство.", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("path", { d: "m6 9 6 6 6-6" }, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "warning__content"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode(" К авиа перевозке не принимаются опасные грузы, в том числе: <ul data-v-76326410><li data-v-76326410>отдельные батареи и аккумуляторы;</li><li data-v-76326410>Power Bank;</li><li data-v-76326410>аэрозоли и газы;</li><li data-v-76326410>легковоспламеняющиеся жидкости;</li><li data-v-76326410>химические вещества;</li><li data-v-76326410>взрывчатые вещества;</li><li data-v-76326410>токсичные и инфекционные вещества;</li><li data-v-76326410>радиоактивные материалы;</li><li data-v-76326410>коррозионные вещества;</li><li data-v-76326410>другие товары, классифицируемые как опасные грузы.</li></ul>", 2)
const _hoisted_37 = {
  key: 4,
  class: "body__files"
}
const _hoisted_38 = {
  key: 5,
  class: "body__files"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("label", { class: "body__label" }, " Укажите информацию о наложенном платеже и объявленной стоимости ", -1)
const _hoisted_40 = {
  key: 8,
  class: "bottom-border"
}
const _hoisted_41 = { class: "body__col col-right" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", { class: "body__label" }, "Укажите параметры доставки и оплаты", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("label", { class: "body__label label-big" }, "Транспорт доставки", -1)
const _hoisted_44 = {
  key: 0,
  style: {"margin-top":"6px","font-weight":"bold"}
}
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { class: "body__label label-big" }, "Способ оплаты за доставку", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("label", { class: "body__label label-big" }, "Кем будет производиться оплата", -1)
const _hoisted_47 = {
  key: 1,
  style: {"margin-top":"6px"}
}
const _hoisted_48 = {
  key: 2,
  style: {"margin-top":"6px"}
}
const _hoisted_49 = { class: "LTLCargoPayment__footer" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Подтвердить")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Сохранить")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_input = _resolveComponent("s-input")!
  const _component_icon_number = _resolveComponent("icon-number")!
  const _component_icon_weight = _resolveComponent("icon-weight")!
  const _component_icon_places = _resolveComponent("icon-places")!
  const _component_icon_length = _resolveComponent("icon-length")!
  const _component_icon_width = _resolveComponent("icon-width")!
  const _component_icon_height = _resolveComponent("icon-height")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_icon_comment = _resolveComponent("icon-comment")!
  const _component_s_textarea = _resolveComponent("s-textarea")!
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_icon_refresh = _resolveComponent("icon-refresh")!
  const _component_uploaded_file = _resolveComponent("uploaded-file")!
  const _component_file_loader = _resolveComponent("file-loader")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_icon_declared_price = _resolveComponent("icon-declared-price")!
  const _component_s_radio_group = _resolveComponent("s-radio-group")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, [
        (!_ctx.isUpdate)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_4
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_5
            ], 64))
      ])
    ]),
    (_ctx.opened)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_s_input, {
                placeholder: "Наименование товара",
                value: _ctx.state.product_name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.product_name = $event)),
                "is-invalid": _ctx.v$.product_name.$error
              }, null, 8, ["value", "is-invalid"]),
              _createVNode(_component_s_input, {
                placeholder: _ctx.customInvoiceNumberPlaceholder,
                value: _ctx.state.customerInvoiceNumber,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.customerInvoiceNumber = $event)),
                "is-invalid": _ctx.v$.customerInvoiceNumber.$error,
                maxlength: "30"
              }, {
                icon: _withId(() => [
                  _createVNode(_component_icon_number)
                ]),
                _: 1
              }, 8, ["placeholder", "value", "is-invalid"]),
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_s_input, {
                  placeholder: "Вес груза",
                  value: _ctx.state.weight,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.weight = $event)),
                  "is-invalid": Boolean(_ctx.v$.weight.$errors.length)
                }, {
                  icon: _withId(() => [
                    _createVNode(_component_icon_weight)
                  ]),
                  _: 1
                }, 8, ["value", "is-invalid"]),
                _createVNode(_component_s_input, {
                  placeholder: "Количество мест",
                  value: _ctx.state.places,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.places = $event)),
                  "is-invalid": Boolean(_ctx.v$.places.$errors.length)
                }, {
                  icon: _withId(() => [
                    _createVNode(_component_icon_places)
                  ]),
                  _: 1
                }, 8, ["value", "is-invalid"])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_s_input, {
                  placeholder: "Макс. длина (см)",
                  value: _ctx.state.length,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.length = $event)),
                  "is-invalid": Boolean(_ctx.v$.length.$errors.length)
                }, {
                  icon: _withId(() => [
                    _createVNode(_component_icon_length)
                  ]),
                  _: 1
                }, 8, ["value", "is-invalid"]),
                _createVNode(_component_s_input, {
                  placeholder: "Макс. ширина (см)",
                  value: _ctx.state.width,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.width = $event)),
                  "is-invalid": Boolean(_ctx.v$.width.$errors.length)
                }, {
                  icon: _withId(() => [
                    _createVNode(_component_icon_width)
                  ]),
                  _: 1
                }, 8, ["value", "is-invalid"]),
                _createVNode(_component_s_input, {
                  placeholder: "Макс. высота (см)",
                  value: _ctx.state.height,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.height = $event)),
                  "is-invalid": Boolean(_ctx.v$.height.$errors.length)
                }, {
                  icon: _withId(() => [
                    _createVNode(_component_icon_height)
                  ]),
                  _: 1
                }, 8, ["value", "is-invalid"])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_s_checkbox, {
                    theme: "primary",
                    label: "Обрешетка",
                    value: _ctx.state.hasGrid,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.hasGrid = $event))
                  }, null, 8, ["value"]),
                  (_ctx.additionalServices.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode("span", null, [
                          _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('grid', 'minValue')) + " м", 1),
                          _hoisted_14
                        ]),
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.getValue('grid', 'price')) + " тг/м", 1),
                          _hoisted_15
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_s_checkbox, {
                    theme: "primary",
                    label: "Паллета",
                    value: _ctx.state.hasPallet,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.hasPallet = $event))
                  }, null, 8, ["value"]),
                  (_ctx.additionalServices.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_17, [
                        _createVNode("span", null, [
                          _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('pallet', 'minValue')) + " м", 1),
                          _hoisted_18
                        ]),
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.getValue('pallet', 'price')) + " тг/м", 1),
                          _hoisted_19
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode(_component_s_checkbox, {
                    theme: "primary",
                    label: "Мягкая упаковка",
                    value: _ctx.state.hasSoftPackage,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.hasSoftPackage = $event))
                  }, null, 8, ["value"]),
                  (_ctx.additionalServices.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _createVNode("span", null, [
                          _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('soft_package', 'minValue')) + " м", 1),
                          _hoisted_22
                        ]),
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.getValue('soft_package', 'price')) + " тг/м", 1),
                          _hoisted_23
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_s_textarea, {
                placeholder: "Примечания к отправке",
                value: _ctx.state.annotation,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.annotation = $event)),
                "is-invalid": _ctx.v$.annotation.$error
              }, {
                icon: _withId(() => [
                  _createVNode(_component_icon_comment)
                ]),
                _: 1
              }, 8, ["value", "is-invalid"]),
              _createVNode("div", null, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", null, [
                    _createVNode(_component_s_checkbox, {
                      theme: "primary",
                      label: "Возвратные документы",
                      "additional-label": "Платная услуга",
                      value: _ctx.state.isReturnDocuments,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.isReturnDocuments = $event))
                    }, null, 8, ["value"])
                  ]),
                  (
                                    Boolean(_ctx.data_state.verify.type) || _ctx.data_state.verify.is_failed
                                )
                    ? (_openBlock(), _createBlock("div", _hoisted_25, [
                        (_ctx.data_state.verify.is_failed)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              style: {"display":"flex","align-items":"center","cursor":"pointer","margin-top":"16px"},
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.loadVerifyType && _ctx.loadVerifyType(...args)))
                            }, [
                              (_ctx.data_state.verify.is_loading)
                                ? (_openBlock(), _createBlock(_component_s_loader, {
                                    key: 0,
                                    style: {"width":"25px","height":"25px"}
                                  }))
                                : (_openBlock(), _createBlock(_component_icon_refresh, {
                                    key: 1,
                                    style: {"width":"30px","height":"30px"}
                                  })),
                              _hoisted_26
                            ]))
                          : (Boolean(_ctx.data_state.verify.type))
                            ? (_openBlock(), _createBlock(_component_s_checkbox, {
                                key: 1,
                                theme: "primary",
                                label: "Верифицировать",
                                value: _ctx.state.verify,
                                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.verify = $event))
                              }, null, 8, ["value"]))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_s_checkbox, {
                    theme: "primary",
                    label: "Застраховать груз",
                    value: _ctx.state.isInsecure,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.isInsecure = $event))
                  }, null, 8, ["value"]),
                  _createVNode(_component_s_checkbox, {
                    theme: "primary",
                    label: "Опасный груз",
                    value: _ctx.state.is_dangerous,
                    "onUpdate:value": [
                      _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.is_dangerous = $event)),
                      _ctx.onIsDangerousChange
                    ]
                  }, null, 8, ["value", "onUpdate:value"]),
                  (_ctx.isCommercialReturnEnabledBySetting)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_s_checkbox, {
                          theme: "primary",
                          label: "Коммерческий возврат",
                          value: _ctx.state.is_commercial_return,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.is_commercial_return = $event))
                        }, null, 8, ["value"]),
                        _hoisted_27,
                        (_ctx.state.is_commercial_return)
                          ? (_openBlock(), _createBlock(_component_s_checkbox, {
                              key: 0,
                              theme: "primary",
                              label: "Нужно фото при заборе",
                              disabled: "",
                              value: _ctx.state.is_commercial_return,
                              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.is_commercial_return = $event))
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.state.is_dangerous)
                ? (_openBlock(), _createBlock("div", _hoisted_28, [
                    _createVNode(_component_uploaded_file, {
                      "is-visible": _ctx.isInvoiceFiles,
                      files: _ctx.files_backend_state.invoice_files,
                      loading: _ctx.files_state.is_loading,
                      title: "Файлы накладной",
                      onDelete: _cache[19] || (_cache[19] = (value) => _ctx.deleteFile(value, 'invoice'))
                    }, null, 8, ["is-visible", "files", "loading"]),
                    _createVNode(_component_file_loader, {
                      value: _ctx.files_state.invoice_files,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (_ctx.files_state.invoice_files = $event)),
                      placeholder: "Загрузите файл накладной",
                      "loaded-files-placeholder": "Файл накладной",
                      "is-invalid": _ctx.files$.invoice_files.$error,
                      "is-multi-select": "",
                      "is-small": ""
                    }, null, 8, ["value", "is-invalid"]),
                    _createVNode(_component_uploaded_file, {
                      "is-visible": _ctx.isCertificate,
                      files: _ctx.files_backend_state.certificate_of_safety_files,
                      loading: _ctx.files_state.is_loading,
                      title: "Сертификаты безопасности",
                      class: "my-5",
                      onDelete: _cache[21] || (_cache[21] = (value) => _ctx.deleteFile(value, 'certificate'))
                    }, null, 8, ["is-visible", "files", "loading"]),
                    _createVNode(_component_file_loader, {
                      value: _ctx.files_state.certificate_of_safety_files,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => (_ctx.files_state.certificate_of_safety_files = $event)),
                      placeholder: "Загрузите сертификат безопасности",
                      "loaded-files-placeholder": "Сертификат безопасности",
                      "is-invalid": _ctx.files$.certificate_of_safety_files.$error,
                      "is-multi-select": "",
                      "is-small": ""
                    }, null, 8, ["value", "is-invalid"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_29, [
                _createVNode(_component_s_checkbox, {
                  theme: "primary",
                  label: "Температурный режим",
                  value: _ctx.state.is_temperature_regime_active,
                  "onUpdate:value": [
                    _cache[23] || (_cache[23] = ($event: any) => (_ctx.state.is_temperature_regime_active = $event)),
                    _ctx.onTemperatureRegimeChange
                  ]
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              (_ctx.state.is_temperature_regime_active)
                ? (_openBlock(), _createBlock(_component_multiselect, {
                    key: 1,
                    class: ["body__temperature", { invalid: _ctx.v$.temperature_regime_type_id.$errors.length }],
                    loading: _ctx.state.is_loading,
                    placeholder: "Температурный режим",
                    modelValue: _ctx.state.temperature_regime_type_id,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.state.temperature_regime_type_id = $event)),
                    options: _ctx.data_state.temperature_regimes.list,
                    label: "title",
                    noOptionsText: "Список пуст"
                  }, null, 8, ["loading", "modelValue", "options", "class"]))
                : _createCommentVNode("", true),
              (_ctx.state.shipmentType && _ctx.state.shipmentType.id === 2)
                ? (_openBlock(), _createBlock("div", _hoisted_30, [
                    _createVNode(_component_multiselect, {
                      placeholder: "Наличие батарейки/аккумулятора",
                      label: "name",
                      modelValue: _ctx.state.has_battery,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.state.has_battery = $event)),
                      options: [{ id: 1, name: 'Да', value: 1 }, { id: 2, name: 'Нет', value: 2 }],
                      class: { invalid: _ctx.v$.has_battery.$errors.length }
                    }, null, 8, ["modelValue", "class"]),
                    _createVNode(_component_multiselect, {
                      placeholder: "Наличие автозапчастей",
                      label: "name",
                      modelValue: _ctx.state.has_auto_parts,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.state.has_auto_parts = $event)),
                      options: [{ id: 1, name: 'Да', value: 1 }, { id: 2, name: 'Нет', value: 2 }],
                      class: { invalid: _ctx.v$.has_auto_parts.$errors.length }
                    }, null, 8, ["modelValue", "class"])
                  ]))
                : _createCommentVNode("", true),
              ((_ctx.state.shipmentType && _ctx.state.shipmentType.id === 2) && _ctx.state.has_battery === 1)
                ? (_openBlock(), _createBlock("div", _hoisted_31, [
                    _createVNode("div", {
                      class: "warning__header",
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.isWarningContentOpened = !_ctx.isWarningContentOpened))
                    }, [
                      _hoisted_32,
                      (_openBlock(), _createBlock("svg", {
                        class: { 'rotate': _ctx.isWarningContentOpened },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _hoisted_33
                      ], 2))
                    ]),
                    (_ctx.isWarningContentOpened)
                      ? (_openBlock(), _createBlock("div", _hoisted_34, [
                          _hoisted_35
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.shipmentType && _ctx.state.shipmentType.id === 2)
                ? (_openBlock(), _createBlock("div", _hoisted_37, [
                    _createVNode(_component_uploaded_file, {
                      "is-visible": _ctx.isMsds,
                      files: _ctx.files_backend_state.msds_file,
                      loading: _ctx.files_state.is_loading,
                      title: "Паспорт безопасности MSDS",
                      onDelete: _cache[28] || (_cache[28] = (value) => _ctx.deleteFile(value, 'msds'))
                    }, null, 8, ["is-visible", "files", "loading"]),
                    _createVNode(_component_file_loader, {
                      value: _ctx.files_state.msds_file,
                      "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => (_ctx.files_state.msds_file = $event)),
                      placeholder: "Паспорт безопасности MSDS",
                      "loaded-files-placeholder": "Паспорт безопасности MSDS",
                      "is-small": ""
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.is_temperature_regime_active)
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    _createVNode(_component_uploaded_file, {
                      "is-visible": _ctx.isTemperature,
                      files: _ctx.files_backend_state.temperature_regime_safety_files,
                      loading: _ctx.files_state.is_loading,
                      title: "Паспорт безопасности температурного режима",
                      class: "my-5",
                      onDelete: _cache[30] || (_cache[30] = (value) => _ctx.deleteFile(value, 'temperature'))
                    }, null, 8, ["is-visible", "files", "loading"]),
                    _createVNode(_component_file_loader, {
                      value: _ctx.files_state.temperature_regime_safety_files,
                      "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => (_ctx.files_state.temperature_regime_safety_files = $event)),
                      placeholder: "Загрузите паспорт безопасности",
                      "loaded-files-placeholder": "Паспорт безопасности",
                      "is-invalid": _ctx.files$.temperature_regime_safety_files.$error,
                      "is-multi-select": "",
                      "is-small": ""
                    }, null, 8, ["value", "is-invalid"])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_39,
              (_ctx.state.isInsecure)
                ? (_openBlock(), _createBlock(_component_s_input, {
                    key: 6,
                    placeholder: "Наименование груза",
                    value: _ctx.state.cargo_name,
                    "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => (_ctx.state.cargo_name = $event)),
                    "is-invalid": Boolean(_ctx.v$.cargo_name.$errors.length)
                  }, null, 8, ["value", "is-invalid"]))
                : _createCommentVNode("", true),
              (_ctx.state.isInsecure)
                ? (_openBlock(), _createBlock(_component_s_input, {
                    key: 7,
                    placeholder: "Объявленная стоимость",
                    value: _ctx.state.declaredPrice,
                    "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => (_ctx.state.declaredPrice = $event)),
                    "is-invalid": Boolean(_ctx.v$.declaredPrice.$errors.length)
                  }, {
                    icon: _withId(() => [
                      _createVNode(_component_icon_declared_price)
                    ]),
                    _: 1
                  }, 8, ["value", "is-invalid"]))
                : _createCommentVNode("", true),
              (_ctx.state.isInsecure)
                ? (_openBlock(), _createBlock("div", _hoisted_40))
                : _createCommentVNode("", true),
              _createVNode(_component_s_input, {
                placeholder: "Наложенный платёж",
                value: _ctx.state.codPayment,
                "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => (_ctx.state.codPayment = $event)),
                "is-invalid": Boolean(_ctx.v$.codPayment.$errors.length)
              }, null, 8, ["value", "is-invalid"])
            ]),
            _createVNode("div", _hoisted_41, [
              _hoisted_42,
              _hoisted_43,
              _createVNode(_component_s_radio_group, {
                options: 
                            _ctx.isOnlyAuto ? _ctx.SHIPMENT_TYPE_OPTIONS_ONLY_AUTO : _ctx.SHIPMENT_TYPE_OPTIONS
                        ,
                theme: "primary",
                value: _ctx.state.shipmentType,
                "onUpdate:value": [
                  _cache[35] || (_cache[35] = ($event: any) => (_ctx.state.shipmentType = $event)),
                  _ctx.onShipmentTypeChange
                ]
              }, null, 8, ["options", "value", "onUpdate:value"]),
              (_ctx.isOnlyAuto)
                ? (_openBlock(), _createBlock("span", _hoisted_44, "Внутригородскую доставку нельзя отправлять самолётом"))
                : _createCommentVNode("", true),
              _hoisted_45,
              _createVNode(_component_s_radio_group, {
                options: _ctx.data_state.payment_methods,
                theme: "primary",
                value: _ctx.state.paymentMethod,
                "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => (_ctx.state.paymentMethod = $event)),
                onChange: _ctx.onPaymentMethodChange
              }, null, 8, ["options", "value", "onChange"]),
              _hoisted_46,
              _createVNode(_component_s_radio_group, {
                options: _ctx.getPaymentTypeOptions,
                "name-additional": _ctx.senderTitle,
                theme: "primary",
                value: _ctx.state.paymentType,
                "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => (_ctx.state.paymentType = $event)),
                "disabled-options-ids": _ctx.disabledPaymentTypeOptionsIds,
                onChange: _ctx.onPaymentTypeChange
              }, null, 8, ["options", "name-additional", "value", "disabled-options-ids", "onChange"]),
              (!_ctx.state.payers.length && _ctx.isTransferPayment)
                ? (_openBlock(), _createBlock("span", _hoisted_47, " Для оплаты третьим лицом или плательщиком обратитесь к вашему менеджеру "))
                : _createCommentVNode("", true),
              (_ctx.isChlNotFoundWarning)
                ? (_openBlock(), _createBlock("span", _hoisted_48, " Для оплаты наличными или платежами Kaspi обратитесь к вашему менеджеру "))
                : _createCommentVNode("", true),
              (_ctx.isOnPayersSelect())
                ? (_openBlock(), _createBlock(_component_multiselect, {
                    key: 3,
                    loading: _ctx.state.is_loading,
                    modelValue: _ctx.state.payer_company_id,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.state.payer_company_id = $event)),
                    options: _ctx.state.payers.filter((p) => !p.isChl),
                    placeholder: "Плательщик",
                    label: "name",
                    noOptionsText: "Список пуст",
                    class: ["payers-select", { invalid: _ctx.v$.payer_company_id.$errors.length }],
                    onChange: _ctx.onPayerSelect
                  }, null, 8, ["loading", "modelValue", "options", "class", "onChange"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_49, [
            _createVNode(_component_s_button, {
              class: "primary",
              loading: _ctx.loading || _ctx.state.is_loading,
              disabled: _ctx.state.is_loading,
              onClick: _ctx.confirmHandler
            }, {
              default: _withId(() => [
                (!_ctx.isUpdate)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_50
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_51
                    ], 64))
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
})